<template>
  <div class="audit__log__box">
    <div
      class="audit-log-list d-flex"
      role="tablist"
      v-if="auditLogs.total > 0"
    >
      <b-card
        no-body
        class="mb-4 item"
        :key="Math.random() * index"
        v-for="(auditLog, index) in auditLogs.data"
      >
        <b-card-header header-tag="header" role="tab">
          <b-button
            block
            v-b-toggle="'auditLog-' + auditLog.id"
            class="accordion-btn pointer-default"
            variant="theme"
          >
            <span class="float-left audit__log__texts">
              <i
                class="fa-fw"
                :class="logTypeIcon(auditLog.audit_log_type_id)"
              ></i>
              <span class="fw-bold">{{ auditLog.type.type }}</span> by
              <span class="fw-bold">{{ auditLog.updating_user }}</span>
            </span>
            <span class="float-left float-md-right audit__log__texts">
              {{
                auditLog.created_at | moment("DD MMM, YYYY @ H:mm")
              }}
            </span>
          </b-button>
        </b-card-header>
        <div
          :id="'auditLog-' + auditLog.id"
          :visible="expandAll"
          :accordion="'auditLog-' + auditLog.id"
          role="tabpanel"
        >
          <b-card-body>
              <p v-if="auditLog.audit_log_type_id == 19" class="log-infos">
              <span><div class='fw-bold'>Profile</div> </span>
            </p>
            <p v-if="auditLog.deliverable_title || auditLog.task_title || auditLog.project_title" class="d-flex no-gutters log-infos flex-wrap">
              <span class="col-12 col-md-6" v-if="auditLog.deliverable_title"><div class='fw-bold'>Deliverable</div>{{ auditLog.deliverable_title }}</span><br>
              <span class="col-12 col-md-6" v-if="auditLog.project_title"><div class='fw-bold'>Project</div>{{ auditLog.project_title }}</span><br>
              <span class="col-12 col-md-6" v-if="auditLog.task_title"><div class='fw-bold'>Task</div>{{ auditLog.task_title }} </span>
            </p>
            <p v-if="auditLog.audit_log_type_id == 16" class="d-flex no-gutters log-infos flex-wrap">
              <span class="col-12 col-md-6"><div class='fw-bold'>Project</div>{{ parseJSON(auditLog.api_params).title }}</span><br>
            </p>
            <p v-if="auditLog.audit_log_type_id == 9 || auditLog.audit_log_type_id == 10" class="log-infos">
              <span><div class='fw-bold'>Coordinator</div> {{ parseJSON(auditLog.new_value).first_name + ' ' + parseJSON(auditLog.new_value).last_name }}</span>
            </p>
            <p v-if="auditLog.audit_log_type_id == 4" class="log-infos">
              <span><div class='fw-bold'>Department</div> {{ parseJSON(auditLog.new_value).title }}</span>
            </p>
            <p v-if="auditLog.audit_log_type_id == 6" class="log-infos">
              <span><div class='fw-bold'>Tag</div> {{ parseJSON(auditLog.new_value).tag }}</span>
            </p>
            <p v-if="auditLog.audit_log_type_id == 8" class="log-infos">
              <span><div class='fw-bold'>Contact</div> {{ parseJSON(auditLog.new_value).first_name + ' ' + parseJSON(auditLog.new_value).last_name }}</span>
            </p>
            <p v-if="auditLog.audit_log_type_id == 22" class="d-flex no-gutters log-infos flex-wrap">
              <span class="col-12 col-md-6"><div class='fw-bold'>Role</div>{{ parseJSON(auditLog.new_value).title }}</span><br>
            </p>
            <span v-html="processAuditLog(auditLog)"> </span>
          </b-card-body>
        </div>
      </b-card>
    </div>
    <div v-else>
        <div class="mb-5"><h2>Logs not found</h2></div>
    </div>
    <div v-if="auditLogs.total > 0" class="pagination-wrapper">
      <pagination
        :data="auditLogs"
        @pagination-change-page="onChangePage"
        :limit="5"
      ></pagination>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { diff } from "json-diff";
export default {
  props: ["auditLogs"],
  data() {
    return {
      expandAll: true,
    };
  },
  methods: {
    ...mapActions(["fetchAuditLogs"]),
    parseJSON(jsonStr) {
      return this.tryJSONParse(jsonStr);
    },
    onChangePage(page) {
      this.fetchAuditLogs({ page: page });
    },
    logTypeIcon(logType) {
      let icon = "";
      switch (logType) {
        case 1:
        case 2:
        case 13:
        case 14:
          icon = "fas fa-list";
          break;
        case 3:
        case 4:
          icon = "fas fa-project-diagram";
          break;
        case 5:
        case 6:
          icon = "fas fa-hashtag";
          break;
        case 7:
        case 8:
          icon = "fas fa-id-badge";
          break;
        case 9:
        case 10:
          icon = "fas fa-user-circle";
          break;
        case 11:
        case 12:
        case 15:
          icon = "fas fa-tasks";
          break;
        case 16:
        case 17:
        case 18:
          icon = "fas fa-project-diagram";
          break;
        default:
          break;
      }
      return icon;
    },
    processAuditLog(auditLog) {
      let self = this;
      let jsondiffpatch = require("jsondiffpatch");
      let comparedJson = "";
      let oldValue = auditLog.old_value ? self.tryJSONParse(auditLog.old_value) : null;
      let newValue = auditLog.new_value ? self.tryJSONParse(auditLog.new_value) : null;
      let returnData = "";
      switch (auditLog.audit_log_type_id) {
        case 1: // deliverable updated
        case 17: // project updated
          comparedJson = jsondiffpatch.diff(oldValue, newValue);
          field = !oldValue ? newValue.field : oldValue.field;
          if(comparedJson) {
            let excludes = [
              "id",
              "updated_at",
              "created_at",
              "slug"
            ];
            let jsdiff = require('diff');
            Object.keys(comparedJson).forEach(function (value, key) {
              if (excludes.indexOf(value) == -1) {
                if(!field) {
                  if (value == "deliverable_template_id") {
                    field = {label: "Deliverable Type"};
                  } else {
                    field = {label: (value.replace("_", " ") + "").replace(
                              /^(.)|\s+(.)/g,
                              function ($1) {
                                return $1.toUpperCase();
                              }
                            )};
                  }
                }
                if(field.label == 'Tag' || field.label == 'Department' || field.label == 'Spokesperson' || field.label == 'Contact' || field.field_key == 'project_coordinator') {
                  let oldData = [];
                  let newData = [];
                  let v = '';
                  if(oldValue) {
                    if(typeof oldValue.value == 'string') {
                      oldValue.value = self.tryJSONParse(oldValue.value);
                    }
                    oldValue.value.forEach(function(value, key) {
                      if(field.label == 'Tag') {
                        v = value['tag'];
                      } else if(field.label == 'Department') {
                        v = value['title'];
                      } else if(field.label == 'Spokesperson' || field.label == 'Contact') {
                        v = value['first_name'] + ' ' + value['last_name'];
                      } else if(field.field_key == 'project_coordinator') {
                        v = value['name'];
                      }
                      oldData.push('<span class="badge badge-gray deliverable-tags">' + v + '</span>');
                    });
                  }

                  if(newValue) {
                    if(typeof newValue.value == 'string') {
                      newValue.value = self.tryJSONParse(newValue.value);
                    }
                    newValue.value.forEach(function(value, key) {
                      if(field.label == 'Tag') {
                        v = value['tag'];
                      } else if(field.label == 'Department') {
                        v = value['title'];
                      } else if(field.label == 'Spokesperson' || field.label == 'Contact') {
                        v = value['first_name'] + ' ' + value['last_name'];
                      }
                      newData.push('<span class="badge badge-gray deliverable-tags">' + v + '</span>');
                    });
                  }

                  oldData = oldData.join(' ');
                  newData = newData.join(' ');
                  var diff = jsdiff.diffWords(oldData, newData);

                  if(oldData) {
                    if(returnData == '') {
                      returnData +=
                        "<div><span class='fw-bold'> Old " +
                        field.label +
                        '</span><br/>' +
                        oldData +
                        "<br><br><span class='fw-bold'> New " +
                        field.label +
                        '</span><br/>' +
                        newData +
                        "</div>";
                    }
                  } else {
                    if(returnData == '') {
                      returnData +=
                        "<div><span class='fw-bold'> New " +
                        field.label +
                        '</span><br/>' +
                        newData +
                        "</div>";
                    }
                  }
                } else if(field.label == 'Resources') {
                  if(oldValue) {
                    if(!newValue) {
                      returnData =
                        "<div><span class='fw-bold'> Resource removed</span><br/>" +
                        "Link: <em class='highlight-old'>" + oldValue.value.link + "</em>";
                      if(typeof oldValue.value.label != 'undefined') {
                        returnData += "<br>Label: <em class='highlight-old'>" + oldValue.value.label + "</em>";
                      }
                      if(typeof oldValue.value.notes != 'undefined') {
                        returnData += "<br>Notes: <em class='highlight-old'>" + oldValue.value.notes + "</em>";
                      }
                      returnData += "</div>";
                    } else {
                      returnData = "<div><span class='fw-bold'> Resource updated</span><br/>";
                      if(typeof comparedJson[value].link != 'undefined') {
                        returnData += "Link updated from <em class='highlight-old'>" + comparedJson[value].link[0] + "</em>";
                        returnData += " to <em class='highlight-new'>" + comparedJson[value].link[1] + "</em>";
                      }
                      if(typeof comparedJson[value].label != 'undefined') {
                        if(typeof comparedJson[value].label[1] != 'undefined') {
                          returnData += "<div>Label updated from <em class='highlight-old'>" + comparedJson[value].label[0] + "</em>";
                          returnData += " to <em class='highlight-new'>" + comparedJson[value].label[1] + "</em></div>";
                        } else {
                          returnData += "<div>Label updated to <em class='highlight-new'>" + comparedJson[value].label[0] + "</em></div>";
                        }
                      }
                      if(typeof comparedJson[value].notes != 'undefined') {
                        if(typeof comparedJson[value].notes[1] != 'undefined') {
                          returnData += "<div>Notes updated from <em class='highlight-old'>" + comparedJson[value].notes[0] + "</em>";
                          returnData += " to <em class='highlight-new'>" + comparedJson[value].notes[1] + "</em></div>";
                        } else {
                          returnData += "<div>Notes updated to <em class='highlight-old'>" + comparedJson[value].notes[0] + "</em></div>";
                        }
                      }
                      returnData += "</div>";
                    }
                  } else {
                    returnData =
                      "<div><span class='fw-bold'> Resource added</span><br/>" +
                      "Link set to <em class='highlight-new'>" + newValue.value.link.value + "</em>";
                    if(typeof newValue.value.label != 'undefined') {
                      returnData += "<br>Label set to <em class='highlight-new'>" + newValue.value.label.value + "</em>";
                    }
                    if(typeof newValue.value.notes != 'undefined') {
                      returnData += "<br>Notes set to <em class='highlight-new'>" + newValue.value.notes.value + "</em>";
                    }
                    returnData += "</div>";
                  }
                } else {
                  if(comparedJson[value]) {
                    if (comparedJson[value][0]) {
                      if(field.label == 'Lead Coordinator') {
                        self.$store.dispatch('idToLabel', {table: 'users', returnColumn: 'name', id: comparedJson[value][0]}).then(function(resp1) {
                          self.$store.dispatch('idToLabel', {table: 'users', returnColumn: 'name', id: comparedJson[value][1]}).then(function(resp2) {
                            returnData = '';
                            returnData +=
                              "<div>" +
                              field.label +
                              ' changed from <em class="highlight-old">' +
                              resp1 +
                              '</em> to <em class="highlight-new">' +
                              resp2 +
                              "</em></div>";
                            $('#auditLog-'+auditLog.id+' > .card-body > span').html(returnData);
                          })
                        })
                      } else if (field.label == 'Status') {
                        let val1 = typeof comparedJson[value][0] == 'string' ? comparedJson[value][0].replace(/(<([^>]+)>)/gi, "") : comparedJson[value][0];
                        let val2 = typeof comparedJson[value][1] == 'string' ? comparedJson[value][1].replace(/(<([^>]+)>)/gi, "") : comparedJson[value][1];

                        returnData +=
                          "<div>" +
                          field.label +
                          ' changed from <span class="badge" style="color: var(--wf-secondary); background:'+self.tryJSONParse(val1).color+'"><em class="highlight-old">' +
                          self.tryJSONParse(val1).name +
                          '</em></span> to <span class="badge" style="color: var(--wf-secondary); background:'+val2.color+'"><em class="highlight-new">' +
                          val2.name +
                          "</em></span></div>";
                      } else if (field.label == 'Deliverable Type') {
                        self.$store.dispatch('idToLabel', {table: 'deliverable_templates', returnColumn: 'title', id: comparedJson[value][0]}).then(function(resp1) {
                          self.$store.dispatch('idToLabel', {table: 'deliverable_templates', returnColumn: 'title', id: comparedJson[value][1]}).then(function(resp2) {
                            returnData = '';
                            returnData +=
                              "<div>" +
                              field.label +
                              ' changed from <em class="highlight-old">' +
                              resp1 +
                              '</em> to <em class="highlight-new">' +
                              resp2 +
                              "</em></div>";
                            $('#auditLog-'+auditLog.id+' > .card-body > span').html(returnData);
                          })
                        })
                      } else {
                        let val1 = typeof comparedJson[value][0] == 'string' ? comparedJson[value][0].replace(/(<([^>]+)>)/gi, "") : comparedJson[value][0];
                        let val2 = typeof comparedJson[value][1] == 'string' ? comparedJson[value][1].replace(/(<([^>]+)>)/gi, "") : comparedJson[value][1];

                        returnData +=
                          "<div>" +
                          field.label +
                          ' changed from <em class="highlight-old">' +
                          val1 +
                          '</em> to <em class="highlight-new">' +
                          val2 +
                          "</em></div>";
                      }
                    } else {
                      if (auditLog.api_endpoint == 'addDeliverableToProject') {
                        returnData +=
                        "<div><em class='highlight-new'>" +
                        newValue.title +
                        "</em> deliverable added to <em class='highlight-new'>" +
                        auditLog.project_title +
                        "</em></div>";
                      } else if (auditLog.api_endpoint == 'removeProjectDeliverable') {
                        returnData +=
                        "<div><em class='highlight-old'>" +
                        oldValue.title +
                        "</em> deliverable removed from <em class='highlight-old'>" +
                        auditLog.project_title +
                        "</em></div>";
                      } else if (auditLog.api_endpoint == 'addDeliverableCfContact') {
                        let val3 = comparedJson[value].value[0];
                        returnData +=
                          "<div>" +
                          field.label +
                          " added. <em class='highlight-new'>" +
                          val3.first_name + " " + val3.last_name +
                          "</em></div>";
                      } else if (auditLog.api_endpoint == 'removeDeliverableCfContact') {
                        returnData +=
                          "<div>" +
                          field.label +
                          " removed. </div>";
                      } else if (auditLog.api_endpoint == 'changeProjectEngagementManager' || auditLog.api_endpoint == 'changeProjectLead') {
                        let val3 = typeof comparedJson == 'string' ? comparedJson.replace(/(<([^>]+)>)/gi, "") : comparedJson;
                        if(auditLog.api_endpoint == 'changeProjectEngagementManager') {
                          val3 = val3.engagement_manager
                        }
                        if(auditLog.api_endpoint == 'changeProjectLead') {
                          val3 = val3.project_lead
                        }
                        returnData +=
                          "<div>" +
                          (value.replace("_", " ") + "").replace(
                            /^(.)|\s+(.)/g,
                            function ($1) {
                              return $1.toUpperCase();
                            }
                          ) +
                          ' changed from <em class="highlight-old">' + val3.name[0] + '</em> changed to <em class="highlight-new">' +
                          val3.name[1]
                          "</em></div>";
                      } else if (field.field_key == 'budget' || field.field_key == 'media_budget' || field.field_key == 'requisition_number' || field.field_key == 'project_due_date' || field.field_key == 'color_picker') {
                        let val3 = typeof comparedJson[value][1] == 'string' ? comparedJson[value][1].replace(/(<([^>]+)>)/gi, "") : comparedJson[value][1];
                        returnData +=
                          "<div>" +
                          field.label +
                          ' changed to <em class="highlight-new">' +
                          val3
                          "</em></div>";
                      } else if (field.field_key == 'link_type') {
                        let val3 = comparedJson[value].value;
                        returnData +=
                          "<div>" +
                          (field.label) +
                          ' changed to <em class="highlight-new">' +
                          val3
                        "</em></div>";
                      } else {
                        let val3 = typeof comparedJson[value][1] == 'string' ? comparedJson[value][1].replace(/(<([^>]+)>)/gi, "") : comparedJson[value][1];
                        // returnData +=
                        //   "<div>" +
                        //   (value.replace("_", " ") + "").replace(
                        //     /^(.)|\s+(.)/g,
                        //     function ($1) {
                        //       return $1.toUpperCase();
                        //     }
                        //   ) +
                        //   ' changed to <em class="highlight-new">' +
                        //   val3
                        //   "</em></div>";
                        returnData +=
                          "<div>" +
                          (field.label) +
                          ' changed to <em class="highlight-new">' +
                          val3
                          "</em></div>";
                      }
                    }
                  }
                }
              }
            });
          }
          return returnData;
          break;

        case 2: // task status updated
          if(oldValue && newValue) {
            return (
              'Status was updated from <span class="badge" style="color: var(--wf-secondary); background: ' +
              self.tryJSONParse(oldValue.value).color +
              '"><em>' +
              self.tryJSONParse(oldValue.value).name +
              '</em></span> to <span class="badge" style="color: var(--wf-secondary); background: ' +
              self.tryJSONParse(newValue.value).color +
              '"><em>' +
              self.tryJSONParse(newValue.value).name +
              "</em></span>"
            );
          } else {
            return (
              'Status set to <span class="badge" style="color: var(--wf-secondary); background: ' +
              self.tryJSONParse(newValue.value).color +
              '"><em>' +
              self.tryJSONParse(newValue.value).name +
              "</em></span>"
            );
          }
          break;

        case 3: // department added
          return '<em class="highlight-new">' + newValue.title + '</em> department was added.';
          break;

        case 4: // department updated
          comparedJson = jsondiffpatch.diff(oldValue, newValue);
          if (comparedJson.title) {
            returnData =
              '<div>Title changed from <em class="highlight-old">' +
              comparedJson.title[0] +
              '</em> to <em class="highlight-new">' +
              comparedJson.title[1] +
              "</em></div>";
          }
          if (comparedJson.abbreviation) {
            returnData +=
              '<div>Abbreviation changed from <em class="highlight-old">' +
              comparedJson.abbreviation[0] +
              '</em> to <em class="highlight-new">' +
              comparedJson.abbreviation[1] +
              "</em></div>";
          }
          if (comparedJson.is_active) {
            let oldDepartStatus =
              comparedJson.is_active[0] == 0 ? "Archived" : "Active";
            let newDepartStatus =
              comparedJson.is_active[1] == 0 ? "Archived" : "Active";
            returnData +=
              '<div>Status changed from <em class="highlight-old">' +
              oldDepartStatus +
              '</em> to <em class="highlight-new">' +
              newDepartStatus +
              "</em></div>";
          }
          return returnData;
          break;

        case 5: // tag added
          return '<em class="highlight-new">' + newValue.tag + '</em> tag was added.';
          break;

        case 6: // department updated
          comparedJson = jsondiffpatch.diff(oldValue, newValue);
          if (comparedJson.tag) {
            returnData =
              '<div>Title changed from <em class="highlight-old">' +
              comparedJson.tag[0] +
              '</em> to <em class="highlight-new">' +
              comparedJson.tag[1] +
              "</em></div>";
          }
          if (comparedJson.is_active) {
            let oldDepartStatus =
              comparedJson.is_active[0] == 0 ? "Archived" : "Active";
            let newDepartStatus =
              comparedJson.is_active[1] == 0 ? "Archived" : "Active";
            returnData +=
              '<div>Status changed from <em class="highlight-old">' +
              oldDepartStatus +
              '</em> to <em class="highlight-new">' +
              newDepartStatus +
              "</em></div>";
          }
          return returnData;
          break;

        case 7: // contact added
          return '<em class="highlight-new">' + newValue.first_name + ' ' + newValue.last_name + '</em> contact was added.';
          break;

        case 8: // contact updated
          if (comparedJson) {
            let excludes = [
              "id",
              "last_assigned_at",
              "updated_at",
              "created_at",
              "user_id",
              "email_verified_at",
              "userRoles",
              "name",
            ];
            Object.keys(comparedJson).forEach(function (value, key) {
              if (excludes.indexOf(value) == -1) {
                if (comparedJson[value][0]) {
                  if(value == 'is_active') {
                    let statusVal1 = comparedJson[value][0] ? 'Active' : 'Archived';
                    let statusVal2 = comparedJson[value][1] ? 'Active' : 'Archived';
                    returnData +=
                      '<div> Status changed from <em class="highlight-old">' +
                      statusVal1 +
                      '</em> to <em class="highlight-new">' +
                      statusVal2 +
                      "</em></div>";
                  } else {
                    returnData +=
                      "<div>" +
                      (value.replace("_", " ") + "").replace(
                        /^(.)|\s+(.)/g,
                        function ($1) {
                          return $1.toUpperCase();
                        }
                      ) +
                      ' changed from <em class="highlight-old">' +
                      comparedJson[value][0] +
                      '</em> to <em class="highlight-new">' +
                      comparedJson[value][1] +
                      "</em></div>";
                  }
                } else {
                  returnData +=
                    "<div>" +
                    (value.replace("_", " ") + "").replace(
                      /^(.)|\s+(.)/g,
                      function ($1) {
                        return $1.toUpperCase();
                      }
                    ) +
                    ' changed to <em class="highlight-new">' +
                    comparedJson[value][1] +
                    "</em></div>";
                }
              }
            });
          }
          return returnData;
          break;

        case 9: // user added
          break;

        case 10: // user updated
          comparedJson = jsondiffpatch.diff(oldValue, newValue);
          if (comparedJson) {
            let excludes = [
              "id",
              "last_assigned_at",
              "updated_at",
              "created_at",
              "user_id",
              "email_verified_at",
              "userRoles",
              "name",
            ];
            Object.keys(comparedJson).forEach(function (value, key) {
              if (excludes.indexOf(value) == -1) {
                if (comparedJson[value][0]) {
                  returnData +=
                      "<div>" +
                      (value.replace("_", " ") + "").replace(
                        /^(.)|\s+(.)/g,
                        function ($1) {
                          return $1.toUpperCase();
                        }
                      ) +
                      ' changed from <em class="highlight-old">' +
                      comparedJson[value][0] +
                      '</em> to <em class="highlight-new">' +
                      comparedJson[value][1] +
                      "</em></div>";
                } else {
                  returnData +=
                    "<div>" +
                    (value.replace("_", " ") + "").replace(
                      /^(.)|\s+(.)/g,
                      function ($1) {
                        return $1.toUpperCase();
                      }
                    ) +
                    ' changed to <em class="highlight-new">' +
                    comparedJson[value][1] +
                    "</em></div>";
                }
              } else if(value == 'userRoles') {
                let oldData = [];
                let newData = [];
                oldValue.userRoles.forEach(function(value, key) {
                  oldData.push('<span class="badge badge-gray deliverable-tags">' + value['name'] + '</span>');
                });
                newValue.userRoles.forEach(function(value, key) {
                  newData.push('<span class="badge badge-gray deliverable-tags">' + value['name'] + '</span>');
                });
                oldData = oldData.join(' ');
                newData = newData.join(' ');
                returnData +=
                  "<div><span class='fw-bold'> Old Roles</span><br/>" +
                  oldData +
                  "<br><span class='fw-bold'> New Roles</span><br/>" +
                  newData +
                  "</div>";
              }
            });
          }
          return returnData;
          break;

        case 11: // task updated
          comparedJson = jsondiffpatch.diff(oldValue, newValue);
          let field = !oldValue ? newValue.field : oldValue.field;
          let oldDisplayValue = oldValue
            ? oldValue.valueLabel
              ? oldValue.valueLabel
              : oldValue.value
            : "";
          let newDisplayValue = newValue
            ? newValue.valueLabel
              ? newValue.valueLabel
              : newValue.value
            : "";
          if (!oldDisplayValue) {
            if (field.field_key == "due_date") {
              newDisplayValue = this.$moment(newDisplayValue).format(
                "DD MMM, YYYY"
              );
            }
            return (
              field.label +
              ' was set to <em class="highlight-new">' +
              newDisplayValue +
              "</em>"
            );
          } else {
            if (field.field_key == "due_date") {
              oldDisplayValue = this.$moment(oldDisplayValue).format(
                "DD MMM, YYYY"
              );
              newDisplayValue = this.$moment(newDisplayValue).format(
                "DD MMM, YYYY"
              );
            }
            return (
              field.label +
              ' was updated from <em class="highlight-old">' +
              oldDisplayValue +
              '</em> to <em class="highlight-new">' +
              newDisplayValue +
              "</em>"
            );
          }
          break;

        case 12: // task deleted
          return '<em class="highlight-old">' + oldValue.taskData.title + '</em> task was removed.';
          break;

        case 13: // call deleted
          if(!oldValue) return;
          return '<em class="highlight-old">' + oldValue.deliverableData.title + '</em> was removed.';
          break;

        case 14: // call duplicated
          if(!newValue || !oldValue) return;
          return '<em class="highlight-new">' + newValue.deliverableData.title + '</em> was duplicated from <em>' + oldValue.deliverableData.title + '</em>';
          break;

        case 15: // task added
          return '<em class="highlight-new">' + newValue.title + '</em> task was added.';
          break;

        case 16: // project created
          break;

        case 18: // project deleted
          if(!oldValue) return;
          return '<em class="highlight-old">' + oldValue.projectData.title + '</em> was removed.';
          break;

        case 21: // Role created
          if(!newValue) return;
          return '<em class="highlight-new">' + newValue.title + '</em> was created.';
          break;
        case 22: // Role updated
          if(!newValue || !oldValue) return;
          if(newValue.permissions && oldValue.permissions) {
            let jsondiffpatch = require("jsondiffpatch");
            let diff = jsondiffpatch.diff(newValue, oldValue);
            let returnData = "";
            if (diff && diff['permissions']) {
              let oldData = [], newData = [];
              oldValue.permissions.forEach(v => {
                oldData.push('<span class="badge badge-gray deliverable-tags">' + v.title + '</span>');
              });
              newValue.permissions.forEach(v => {
                newData.push('<span class="badge badge-gray deliverable-tags">' + v.title + '</span>');
              });

              oldData = oldData.join(' ');
              newData = newData.join(' ');

              returnData = "<div><span class='fw-bold'> Old Permissions" +
                        '</span><br/>' +
                        oldData +
                        "<br><br><span class='fw-bold'> New Permissions" +
                        '</span><br/>' +
                        newData +
                        "</div>";

            }
            if (diff && diff['default_preference']) {
              let oldPreference = oldValue['default_preference'] ? JSON.parse(oldValue['default_preference'])['deliverable_type'] : [];
              let newPreference = newValue['default_preference'] ? JSON.parse(newValue['default_preference'])['deliverable_type'] : [];

              console.log(newValue);

              let oldPreferenceData = [], newPreferenceData = [];
              oldPreference.forEach(v => {
                oldPreferenceData.push('<span class="badge badge-gray deliverable-tags">' + v.name + '</span>');
              });
              newPreference.forEach(v => {
                newPreferenceData.push('<span class="badge badge-gray deliverable-tags">' + v.name + '</span>');
              });

              oldPreferenceData = oldPreferenceData.join(' ');
              newPreferenceData = newPreferenceData.join(' ');

              returnData += "<div><span class='fw-bold'> Old Preference" +
                        '</span><br/>' +
                        oldPreferenceData +
                        "<br><br><span class='fw-bold'> New Preference" +
                        '</span><br/>' +
                        newPreferenceData +
                        "</div>";
            }

            return returnData;
          } else {
            return '<em class="highlight-old">' + oldValue.title + '</em> changed to <em class="highlight-new">' + newValue.title + '</em>';
          }
          break;
        case 23: // Role deleted
          break;
        case 19: // Profile updated
        // import { diff } from "json-diff";
        comparedJson = diff(oldValue, newValue, {full:false});
        field = !oldValue ? newValue.field : oldValue.field;
          if(comparedJson) {
            let excludes = [
              "id",
              "updated_at",
              "created_at",
              "slug",
              "email_verified_at",
              "password_last_updated",
              "name",
              "id__deleted",
              "password_last_updated__deleted",
              "created_at__deleted",
              "userRoles",
              "email_verified_at__deleted",

            ];
            Object.keys(comparedJson).forEach(function (value, key) {
              if (excludes.indexOf(value) == -1) {
                // if(!field) {
                  if (value == "deliverable_template_id") {
                    field = {label: "Deliverable Type"};
                  } else {
                    field = {label: (value.replace("_", " ") + "").replace(
                              /^(.)|\s+(.)/g,
                              function ($1) {
                                return $1.toUpperCase();
                              }
                            )};
                  }
                  if(comparedJson[value]) {
                      if(field.label == 'Preferences') {
                        let val1 = self.tryJSONParse(comparedJson[value].__old).deliverable_type;
                        let val2 = self.tryJSONParse(comparedJson[value].__new).deliverable_type;
                        let returnOldValues = "";
                        let returnNewValues = "";
                        Object.keys(val1).forEach(function (value) {
                            returnOldValues += val1[value].name;
                            if ( (val1.length -1) != value ) returnOldValues += ", ";
                        });
                        Object.keys(val2).forEach(function (value) {
                            returnNewValues += val2[value].name;
                            if ( (val2.length -1) != value ) returnNewValues += ", ";
                        });
                        returnData +=
                          "<div>" +
                          field.label +
                          ' changed from <em class="highlight-old">' +
                          returnOldValues +
                          '</em> to <em class="highlight-new">' +
                          returnNewValues +
                          "</em></div>";
                      } else {
                        let val1 = typeof comparedJson[value].__old == 'string' ? comparedJson[value].__old.replace(/(<([^>]+)>)/gi, "") : comparedJson[value].__old;
                        let val2 = typeof comparedJson[value].__new == 'string' ? comparedJson[value].__new .replace(/(<([^>]+)>)/gi, "") : comparedJson[value].__new ;

                        returnData +=
                          "<div>"+
                          field.label +
                          ' changed from <em class="highlight-old">' +
                          val1 +
                          '</em> to <em class="highlight-new">' +
                          val2 +
                          "</em></div>";
                      }
                  }
              }
            });
          }
          return returnData;
        break;
      }
    },
  },
  mounted() {
    // let self = this;
    // this.$root.$on('toggle-all-audit-logs', (state) => {
    //   console.log(state);
    //   self.expandAll = state;
    // });
  },
};
</script>

<style>
</style>
